var getRandomFromArray = function (arr) {
    return arr[Math.floor(Math.random() * arr.length)];
};
export { getRandomFromArray };
